import { render, staticRenderFns } from "./DxBinsCreateGrid.vue?vue&type=template&id=b07f24aa&"
import script from "./DxBinsCreateGrid.vue?vue&type=script&lang=js&"
export * from "./DxBinsCreateGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports